<template>
  <div id="app">
    <a-config-provider :locale="locales[$i18n.locale]">
      <keep-alive>
        <router-view />
      </keep-alive>
    </a-config-provider>
  </div>
</template>

<style lang="less">
body {
  background: #fff;
  text-align: center;
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: auto;
  height: 100%;
}
.ant-layout {
  background: #efefef;
}

// 上传图片的蒙版
.ant-upload-list-picture-card .ant-upload-list-item-info::before {
  left: 0px;
}
// 弹窗内容
// .ant-modal-content {
// 	height: 100%;
// 	width: 100%;
// }
// 自定义弹窗样式
// .dialogClass {
// 	height: 85% !important;
// 	width: 60% !important;
// }
// tabs
.ant-tabs {
  height: 100%;
}
// tabpane
.ant-tabs-tabpane {
  height: 100%;
}
// tabs-content
.ant-tabs-content {
  height: 100%;
}
// 日期范围筛选器下拉框样式
.dateRangeClass {
  .ant-calendar-range {
    width: 500px;
  }
}
// modal的title
.ant-modal-title {
  font-size: 18px;
}
// 分页
// .ant-pagination-simple .ant-pagination-simple-pager input:nth-child(1) {
// 	width: 40px;
// }
.ant-modal-footer {
  text-align: center !important;
}

// 表格行样式
.ant-table-tbody > tr:hover {
  background-color: #cbf2ff !important;
}
.ant-table-tbody > tr.ant-table-row-selected td {
  background-color: #cbf2ff !important;
}
.ant-table-tbody > tr.ant-table-row-selected:hover {
  background-color: #cbf2ff !important;
}

// 业务调度备注气泡框样式
.popovername .ant-tooltip-inner {
  white-space: break-spaces;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #001529;
}
// table 行高
.ant-table {
  line-height: 1.3 !important;
}
</style>

<script>
// @ is an alias to /src
// import  Menu from '@/components/Menu.vue'
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import vi_VN from "ant-design-vue/lib/locale-provider/vi_VN";
import "moment/locale/zh-cn";
import Util from "@/utils";
Util.localstorage.init();
export default {
  name: "App",
  components: {},
  data() {
    return {
      locales: {
        zh_CN,
        en_US,
        vi_VN,
      },
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (newVal) {
        document.documentElement.lang = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less">
html[lang="vi_VN"] {
  .customer-list-form .input-form .label {
    line-height: 1rem;
    font-size: 0.8rem;
  }
  .customer-list-form .label-name {
    line-height: 1rem;
  }
  .ant-form-item-no-colon,
  .ant-form-item-label {
    white-space: break-spaces;
    display: inline-block;
    line-height: 1rem;
    // margin-top: 10px;
  }
  .ant-form-item {
    display: flex;
    align-items: center;
  }
}
html[lang="en_US"] {
  .customer-list-form .input-form .label {
    line-height: 1rem;
    font-size: 0.8rem;
  }
  .customer-list-form .label-name {
    line-height: 1rem;
  }
  .ant-form-item-no-colon,
  .ant-form-item-label {
    white-space: break-spaces;
    display: inline-block;
    line-height: 1rem;
    // margin-top: 10px;
  }
  .ant-form-item {
    display: flex;
    align-items: center;
  }
}
</style>
